
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export const DataGridRow = ({ className, children, isLast, isSmall }) => {
  const classNameContainer = classNames(className, 'row list-data_row', {
    'is-last': isLast,
    'is-small': isSmall
  })

  return (
    <div className={classNameContainer}>
      {children}
    </div>
  )
}

DataGridRow.defaultProps = {
}

DataGridRow.propTypes = {
  children: PropTypes.node
}
